import { Theme } from '@mui/material/styles'
import { chipClasses } from '@mui/material/Chip'
import { LocationsButtonProps } from '../typings'

export const getStyles = (
  props: LocationsButtonProps,
  theme: Theme,
  tidalThemActive: boolean,
  canCreateLocations?: boolean,
) => {
  return {
    chip: {
      height: '32px',
      [`& .${chipClasses.label}`]: {
        lineHeight: '28px',
        paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(0),
        verticalAlign: 'middle',
      },
      paddingLeft: props.matched
        ? theme.spacing(0)
        : tidalThemActive
        ? theme.spacing(1)
        : canCreateLocations
        ? theme.spacing(0.8)
        : theme.spacing(0.4),
      marginRight: theme.spacing(0),
      paddingRight: props.matched ? theme.spacing(0) : theme.spacing(0.5),
      [`& .${chipClasses.avatarMedium}`]: {
        marginRight: theme.spacing(0),
      },
      borderTopRightRadius: canCreateLocations ? (props.matched ? 16 : 0) : 16,
      borderBottomRightRadius: canCreateLocations
        ? props.matched
          ? 16
          : 0
        : 16,
    },
    header: {
      verticalAlign: props.variant === 'text' ? 'baseline' : 'middle',
      fontWeight: 'medium',
      fontSize: '13px',
      padding: props.matched
        ? '3px 6px'
        : canCreateLocations
        ? '3px 6px'
        : '3px 0px',
      paddingRight: props.matched ? '2px' : canCreateLocations ? '6px' : '0px',
    },
    textHeader: {
      verticalAlign: props.variant === 'text' ? 'baseline' : 'middle',
    },
    button: {
      display: 'flex',
      justifyContent: 'left',
      flexGrow: 0,
      height: '32px',
      lineHeight: '28px',
      padding: '0',
      paddingRight: '0px',
      backgroundColor: '#D4E3F3',
      color: '#002D5C',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderTopRightRadius: '16px',
      borderBottomRightRadius: '16px',
      border: '1px solid #B9B9B9',
    },
    buttonTitle: {
      fontWeight: 'medium',
      fontSize: '13px',
      paddingX: '14px',
    },
  }
}
